import { apiClient } from './apiClient';

const createGiveawayEmbed = async () => {
  return await apiClient.post('/dashboard/giveaway-embed');
};

const fetchGiveawayEmbeds = async () => {
  return await apiClient.get('/dashboard/giveaway-embed');
};

const fetchPublicGiveawayEmbed = async (uuid) => {
  return await apiClient.get(`/embed/${uuid}`);
};

export const giveawayEmbedApi = {
  createGiveawayEmbed,
  fetchGiveawayEmbeds,
  fetchPublicGiveawayEmbed
};
